module.exports = __webpack_public_path__ + "static/img/antiFraud_case_img.6e76781.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/antiFraud/antiFraud_case_img.png
// module id = RB6C
// module chunks = 6